import { createLock } from "../../utils/mutex";

// Shared lock for any function that relies upon and/or updates the last
// successful DB write.
export const lock = createLock();
